export const API_URL = "https://sadguru.hrms.iwebwiser.in/SHRMS/api/v1"; // live
// export const API_URL = 'https://api.yeboeggs.iwebwiser.in/YE001/api/v1'; // dev live
// export const API_URL = "http://82.29.165.216:3211/SHRMS/api/v1"; // local
// export const API_URL = 'http://82.29.165.216:3370/YE001/api/v1'; // local for testing

export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL || "/";

export const API_ENDPOINT = {
  roles: "/roles",
  auth: "/auth",
  admin: "/admin",
  users: "/user",
  Department: `/department`,
  Branch: `/branch`,
  shift: `/shift`,
  oauth: "/oauth",
  clients: "/oauth/clients",
  Designation: "/designation",
  site: `/site`,
  Campus: `/campus`,
  user: "/user",
  leave: "/leave",
  fileUpload: "/file-upload",
  transactions: "/transactions",
  investments: "/investments",
  referrals: "/referrals",
  ranks: "/ranks",
  royalty: "/royalty",
  notification: "/notification",
  createNotification: "/notification/create",
  withdrawals: "/withdrawals",
  adminSettings: "/admin/settings",

  // Site
  settings: "/settings",
  stores: "/store",
  updateStore: "/store/update",
  varients: "/product-variants",
  addons: "/product-addons",
  categories: "/categories",
  products: "/products",
  discounts: "/discounts",
  coupons: "/coupons",
  orders: "/order",
  updateOrderStatus: "/order/update-status",
  assignDriver: "/order/assign-driver",
  drivers: "/driver",
  createDriver: "/user/create-driver",
  updateDriverProfile: "/user/update-driver",
  review: "/review",
  reviewAction: "/review/action",
  homeLayout: "/home-layout",
  storeDashboard: "/store/dashboard",
  tags: "/tags",
  cashSettlement: "/cash-settlement",
  checkoutMessage: "/checkout-message",
  zones: "/zones",
  return: "/return-requests",
  returnReason: "/return-requests/reason",
  media: "/media",
  reportsDashboard: "/reports/dashboard",
  reportsAnalytics: "/reports/analytics",
  payouts: "/payout",
  dashboard: "/dashboard",
  payment: "/payment",
  wallet: "/wallet",
};
